module.exports = __webpack_public_path__ + "static/media/LUDO.78007b23.webp";